import React, { useState } from "react";
import { useStores } from "../../../../../hooks";
import { Hidden, Menu, MenuItem } from "@material-ui/core";
import { Sliders as SlidersIcon } from "react-feather";
import { BookingFormType } from "../../../store/booking/forms";
import { Add as AddIcon } from "@material-ui/icons";
import { Button, Typography } from "../../../../../common/components/libs";
import {Trans, useTranslation} from "react-i18next";

const HeaderButton = () => {
    const [addItemsAnchorMenu, setAddItemsAnchorMenu] = useState(null);
    const [editItemsAnchorMenu, setEditItemsAnchorMenu] = useState(null);
    const { bookingStore } = useStores();

    const { t} = useTranslation(["general", "menu"]);

    return <>
        <Hidden mdUp>
            <Typography variant='h6'>
                { t("general:settings")}
            </Typography>

            <Button
                mt={2}
                onClick={() => {
                    bookingStore.forms.showPopupForm(
                        BookingFormType.editItemsOrdersForm
                    )
                }}
                fullWidth
                variant={'outlined'}
                color={'default'}
            >
                { t("menu:menuEditor.changeOrderItems")}
            </Button>

            <Button
                mt={2}
                onClick={() => {
                    bookingStore.forms.showPopupForm(
                        BookingFormType.editCategoriesForm,
                        bookingStore.currentMenu.menuCategories
                    )
                }}
                aria-haspopup="true"
                fullWidth
                variant={'outlined'}
                color={'default'}
                aria-owns={editItemsAnchorMenu ? "editItemsMenu" : undefined}
            >
                { t("menu:menuEditor.editCategories")}
            </Button>

            <Button
                mt={2}
                onClick={() => {
                    bookingStore.forms.showPopupForm(BookingFormType.createBookingCategory)
                }}
                fullWidth
                variant={'outlined'}
                color={'primary'}
            >
                <span role='img' aria-label="category">📒</span>
                <span style={{ display: 'inline-block', minWidth: 10 }}/>
                { t("menu:menuEditor.toCreateCategory")}
            </Button>

            <Button
                onClick={() => {
                    bookingStore.forms.showPopupForm(BookingFormType.createBookingItem)
                }}
                fullWidth
                variant={'outlined'}
                color={'primary'}
                mt={2}
            >
                <span role='img' aria-label="item">🍕</span>
                <span style={{ display: 'inline-block', minWidth: 10 }}/>
                { t("menu:menuEditor.toAddPosition")}
            </Button>



        </Hidden>
        <Hidden smDown>
            <Button variant="contained"
                    color="default"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => setEditItemsAnchorMenu(e.target)}
                    aria-haspopup="true"
                    aria-owns={editItemsAnchorMenu ? "editItemsMenu" : undefined}

            >
                <SlidersIcon/>
                <span style={{ display: 'inline-block', minWidth: 10 }}/>
                { t("general:settings")}
            </Button>
            <Menu
                id="editItemsMenu"
                anchorEl={editItemsAnchorMenu}
                open={Boolean(editItemsAnchorMenu)}
                onClose={() => setEditItemsAnchorMenu(null)}
            >
                <MenuItem onClick={
                    () => bookingStore.forms.showPopupForm(
                        BookingFormType.editCategoriesForm,
                        bookingStore.currentMenu.menuCategories
                    )
                }>
                    { t("menu:menuEditor.editCategories")}
                </MenuItem>
                <MenuItem onClick={() => bookingStore.forms.showPopupForm(
                    BookingFormType.editItemsOrdersForm
                )}>
                    { t("menu:menuEditor.changeOrderItems")}
                </MenuItem>
            </Menu>
            <span
                style={{ display: "inline-block", minWidth: 20 }}
            />
            <Button variant="contained" color="primary"
                                           onClick={(e: React.MouseEvent<HTMLButtonElement>) => setAddItemsAnchorMenu(e.target)}
                                           aria-haspopup="true"
                                           aria-owns={addItemsAnchorMenu ? "simple-menu" : undefined}

                >
                    <AddIcon/>
                    {t("general:add")}
            </Button>


            <Menu
                id="simple-menu"
                anchorEl={addItemsAnchorMenu}
                open={Boolean(addItemsAnchorMenu)}
                onClose={() => setAddItemsAnchorMenu(null)}
            >
                <MenuItem onClick={() => bookingStore.forms.showPopupForm(BookingFormType.createBookingCategory)}>
                    <span role='img' aria-label="category">📒</span>
                    <span style={{ display: 'inline-block', minWidth: 10 }}/>
                    { t("menu:menuEditor.toCreateCategory")}
                </MenuItem>
                <MenuItem onClick={() => bookingStore.forms.showPopupForm(BookingFormType.createBookingItem)}>
                    <span role='img' aria-label="item">🍕</span>
                    <span style={{ display: 'inline-block', minWidth: 10 }}/>
                    { t("menu:menuEditor.toAddPosition")}
                </MenuItem>
            </Menu>
        </Hidden>
    </>
};

export default HeaderButton
